// web-v2/src/services/bind-holds.service.js
//
// THE SIGNING HOLD'S BROKER DOORS (decision 8; routes/tracon-bind-holds.routes.js,
// broker token only). The sheet reads and decides here and nowhere else.
//
//   getBindHolds(dealId)   GET  /api/tracon/bind-holds?deal=  the holds on one
//                          deal, every word in the server's own (readHoldStates)
//   releaseBindHold(body)  POST /api/tracon/bind-holds/release  the quote stands
//   requoteBindHold(body)  POST /api/tracon/bind-holds/requote  a note, gates nothing
//
// body: { deal_id, quote_id, pilot_key, item_keys } with item_keys exactly the
// open items on screen. The coded answers the sheet words itself (HOLD_CHANGED,
// HOLD_MOOT, HOLD_UNREADABLE) are passed as `expected`, so api.js does not toast
// a generic "API 409" over the sheet's own sentence; the decision door's 400 and
// 500 refusals likewise (the sheet toasts the server's sentence once).
import { api } from '@/lib/api.js';

const BASE = '/api/tracon/bind-holds';
export const HOLD_ANSWERS = Object.freeze([
  { status: 409, code: 'HOLD_CHANGED' },
  { status: 409, code: 'HOLD_MOOT' },
  { status: 503, code: 'HOLD_UNREADABLE' },
  { status: 400, code: 'ITEM_KEYS_REQUIRED' },
  { status: 500, code: 'DECISION_NOT_RECORDED' },
]);

export function getBindHolds(dealId) {
  return api.get(`${BASE}?deal=${encodeURIComponent(dealId)}&_t=${Date.now()}`, { expected: HOLD_ANSWERS });
}

export function releaseBindHold(body) {
  return api.post(`${BASE}/release`, body, { expected: HOLD_ANSWERS });
}

export function requoteBindHold(body) {
  return api.post(`${BASE}/requote`, body, { expected: HOLD_ANSWERS });
}
